import { IPlayerDataLocation, PlayerDataLocation } from 'Utility/DataConflict/DataConflictsHelper';
import IPlayerData, { playerDataKeysToLoad } from 'Player/IPlayerData';
import { GBCHandler } from 'Utility/SDK/GBCHandler';
import { getConflictingSets } from '@platform/Utility/DataConflict/getConflictingSets';
import { playerEndpoint } from 'Player/DataManager';
import Game from 'Game';

export async function fetchDataConflicts(): Promise<IPlayerDataLocation[]> {
    let gameBackendData = await getGameBackendData();
    const dataSets: [IPlayerDataLocation, IPlayerDataLocation] = [
        // Add current device state
        { location: PlayerDataLocation.DEVICE, playerData: playerEndpoint },
        // Add GBC data set
        {
            location: PlayerDataLocation.GAME_BACKEND,
            playerData: gameBackendData,
        },
    ];

    // Get conflicts between provided data sets
    const conflictingSets = getConflictingSets(dataSets);

    // update player endpoint with new end point if there is a conflict with the backend
    const conflictedGameBackendSet = conflictingSets.find(set => set.location === PlayerDataLocation.GAME_BACKEND);
    if (conflictedGameBackendSet) {
        Game.player.data.playerEndpointData = conflictedGameBackendSet.playerData;
    }

    // If there are no conflicts return undefined else return the conflicting sets
    return conflictingSets;
}

async function getGameBackendData(): Promise<IPlayerData | undefined> {
    return GBCHandler.loadFromGBC(playerDataKeysToLoad);
}
